import { LoadingIndicator } from '@components';
import { plans } from '@utils';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { CardHome } from '../../common/components/CardsHome';
import { getDadosCardInicial } from '../../store/plan/thunks';

export const HomePage = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const loadingUser = useSelector((state) => state.user.isLoading);
  const corteExtrato = useSelector(
    (state) => state.configs.dataCorte.data.corteExtrato
  );
  const rentabilidadeDone = useSelector(
    (state) => state.plan.rentabilidade.done
  );
  const patrocinadora = useSelector((state) => state.plan.patrocinadora.data);

  const [hasRequestedCardInicial, setHasRequestedCardInicial] = useState(false);

  const isReady =
    !loadingUser &&
    !!user.data.matricula &&
    !!user.data.plano &&
    !!user.dadosPessoais.nome;

  useEffect(() => {
    if (
      isReady &&
      Array.isArray(corteExtrato) &&
      corteExtrato.length === 2 &&
      !rentabilidadeDone &&
      !hasRequestedCardInicial
    ) {
      dispatch(getDadosCardInicial());
      setHasRequestedCardInicial(true);
    }
  }, [
    dispatch,
    corteExtrato,
    rentabilidadeDone,
    isReady,
    hasRequestedCardInicial,
    user.data.matricula,
    user.data.plano,
  ]);

  return isReady ? (
    <>
      <Helmet>
        <title>Forluz - Home</title>
      </Helmet>
      <div className="d-none d-md-block mb-5 mt-0">
        <span className="text-muted ts-24 ">
          <strong>Olá, {user.dadosPessoais.nome}.&nbsp;</strong>O que você
          precisa hoje?
        </span>
        <br />
        <span className="text-muted ts-20 ">
          <strong>Plano {plans[user.data.plano]}&nbsp;</strong>
          {patrocinadora}
        </span>
      </div>
      <div className="d-block d-md-none text-muted ts-20 mb-5">
        <span className="text-muted ts-24 ">
          <strong>Olá, {user.dadosPessoais.nome}.&nbsp;</strong>O que você
          precisa hoje?
        </span>
        <br />
        <span className="text-muted ts-20 ">
          <strong>Plano {plans[user.data.plano]}&nbsp;</strong>
          {patrocinadora}
        </span>
      </div>
      <CardHome isHomePage />
    </>
  ) : (
    <LoadingIndicator />
  );
};
